import type { RouteRecordRaw } from 'vue-router'

export const subtitlesRoutes: RouteRecordRaw[] = [
  {
    path: 'subtitles',
    name: 'subtitles',
    component: () => import('./views/SubtitlesListView.vue'),
    meta: {
      title: 'Subtitles',
      requires: { permissions: 'subtitles.scribe.access' },
    },
  },
  {
    path: 'subtitles/:assetId/editor',
    name: 'subtitles:editor',
    component: () => import('./views/SubtitlesEditorView.vue'),
    meta: {
      title: 'Editor',
    },
  },
  {
    path: 'subtitles/new/editor',
    name: 'subtitles:editor:new',
    component: () => import('./views/SubtitlesEditorView.vue'),
    meta: {
      title: 'Editor',
    },
  },
  {
    path: 'subtitles/settings',
    component: () => import('./layout/SubtitlesSettingsLayout.vue'),
    meta: {
      title: 'Subtitle Settings',
      requires: { permissions: 'subtitles.scribe.access' },
    },
    children: [
      {
        path: '',
        redirect: { name: 'subtitles:settings:glossary' },
      },
      {
        path: 'glossary',
        name: 'subtitles:settings:glossary',
        component: () => import('./views/settings/GlossaryView.vue'),
        meta: {
          title: 'Glossary',
        },
      },
      {
        path: 'sync',
        name: 'subtitles:settings:sync',
        component: () => import('./views/settings/SyncOptionsView.vue'),
        meta: {
          title: 'Sync Options',
        },
      },
      {
        path: 'style',
        name: 'subtitles:settings:style',
        component: () => import('./views/settings/StyleSettingsView.vue'),
        meta: {
          title: 'Default Style',
        },
      },
    ],
  },
]

export default subtitlesRoutes
